import React from 'react';

const formatTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString();
};

const AutomationLogs = ({ logs, loading, error, onRefresh, range, onRangeChange }) => {
    return (
        <div className="crm-card crm-card-hover">
            <div className="crm-card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 className="crm-card-title">Automation Logs</h2>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <select className="crm-select crm-select-sm" value={range} onChange={(e) => onRangeChange?.(e.target.value)}>
                        <option value="7d">7d</option>
                        <option value="30d">30d</option>
                    </select>
                    <button className="crm-btn crm-btn-secondary crm-btn-sm" onClick={() => onRefresh?.()}>
                        Refresh
                    </button>
                </div>
            </div>
            <div className="crm-card-body">
                {loading ? (
                    <div className="crm-loading">
                        <div className="crm-spinner" />
                    </div>
                ) : error ? (
                    <div className="crm-empty-state">
                        <p>{error.message || 'Failed to load logs'}</p>
                    </div>
                ) : logs.length === 0 ? (
                    <div className="crm-empty-state">
                        <p>No logs yet.</p>
                    </div>
                ) : (
                    <table className="crm-table">
                        <thead>
                            <tr>
                                <th>Time</th>
                                <th>Automation</th>
                                <th>Event</th>
                                <th>Entity</th>
                                <th>Result</th>
                                <th>Error</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log, index) => (
                                <tr key={`${log.eventId}-${index}`}>
                                    <td>{formatTime(log.ts)}</td>
                                    <td>{log.automationId}</td>
                                    <td>{log.eventType || log.eventId}</td>
                                    <td>{log.entity?.type}:{log.entity?.id}</td>
                                    <td>{log.result}</td>
                                    <td>{log.error || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default AutomationLogs;
